/* eslint-disable import/prefer-default-export */
import React from 'react';

import { GetIdentificationOfLetterBlogContsiner } from './containers';

export const GetIdentificationOfLetterBlogWidget = () => <GetIdentificationOfLetterBlogContsiner />;
